import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoComboOption, PoDynamicFormField, PoLookupColumn, PoNotificationService } from '@po-ui/ng-components';
import { Zpr } from 'src/app/interface/zpr';
import { ZprLookupService } from 'src/app/service/zpr-lookup.service';
import { Dano, defaultDano, defaultExpedicaoRomaneioItemPedidoDto, ExpedicaoRomaneioItemPedidoDto } from '../../romaneio/interface/romaneio';
import { RomaneioService } from '../../romaneio/service/romaneio.service';
@Component({
  selector: 'app-controle-danos-cadastro',
  templateUrl: './controle-danos-cadastro.component.html',
  styleUrls: ['./controle-danos-cadastro.component.css']
})
export class ControleDanosCadastroComponent implements OnInit {

  dano: Dano;
  advancedFilter: Array<PoDynamicFormField>;
  ColumnsFilters: Array<PoLookupColumn>;
  FieldFormaterFilter: (value: Zpr) => string;

  envLoteLista: Array<any>;
  responsavelLista: Array<PoComboOption>;

  constructor(
    private romaneioService: RomaneioService,
    private route: ActivatedRoute,
    private poNotificationService: PoNotificationService,
    private router: Router,
    public zprLookupService: ZprLookupService,
  ) {    
    this.responsavelLista = [];
    this.advancedFilter = this.zprLookupService.getAdvancedFilter();
    this.ColumnsFilters = this.zprLookupService.getColumnsFilter();
    this.FieldFormaterFilter = this.zprLookupService.getFieldFormater;
    
    this.dano = defaultDano();

    this.envLoteLista = [
      { value: 'S', label: 'Sim'},
      { value: 'N', label: 'Não'},
      { value: 'A', label: 'Aguardando'},
    ];
   }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if ('CZ03LOTE' in params) {
        this.dano.CZ03LOTE = params['CZ03LOTE']
        this.consultalote();
      } else {
        this.poNotificationService.error("Etiqueta não encontrada!");
      }
    });
    
    this.zprLookupService.grupo = 'DANORESPON';
    this.zprLookupService.getZprLista().subscribe((ret) => {
      this.responsavelLista = ret.items.map((item)=>{
        return {value: item.CZPRCHAVE, label: item.CZPRGENERI}
      });
      this.zprLookupService.grupo = 'MOTIVO';
    });
  }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Cadastro'}
    ]
  }

  consultalote(): void {
    if (this.dano.CZ03LOTE != '') {
      this.romaneioService.consultaLote(this.dano.CZ03LOTE).subscribe({
        next: (ret) => {
          this.dano = ret;
        }, error: () => {
          this.router.navigateByUrl("/estoque/expedicao/danos/lista");
        }
      });
    }
  }

  salvar(): void {
    if (this.dano.CZ03LOTE != '') {
      this.romaneioService.criarRegistro(this.dano).subscribe((ret) => {
        this.poNotificationService.success(`O Dano foi incluído com sucesso. Código ${ret.CZ03COD}`)
        this.router.navigateByUrl("/estoque/expedicao/danos/lista");
      });
    } else {
      this.poNotificationService.error("erro")
    }
  }
}
